<script>

import Swiper from '@/utils/verticalSwiper'
import { nextTick } from 'vue'

export default {
  computed: {
    banner () {
      return this.$store.state.appConfig.loginCarousel.loginCarousels
    }
  },

  mounted () {
    this.$nextTick(() => {
      if (!this.$refs.banner) return

      new Swiper(this.$refs.banner, {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        }
      })
    })
  },
  methods: {}
}
</script>

<template>
  <div class="swiper-container banner-contain" ref="banner">
    <div class="swiper-wrapper">
      <img class="swiper-slide" v-for="item in banner" :key="item.length" :src="item"/>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<style scoped>

.banner-contain {
  width: 100%;
  height: 100%;
  --swiper-pagination-color: #ffffff;
  overflow: hidden;
}

.swiper-slide {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: auto;
  border-radius: 0.4rem;
}
</style>
